module.exports = __webpack_public_path__ + "static/media/coppenrath-wiese-x1.b51a5d6c.png";